import { Theme } from '@mui/material/styles';

export default function InputLabel(theme: Theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.secondary,
        },
        outlined: {
          '&:not(.MuiInputLabel-shrink)': {
            transform: 'translate(14px, 12px) scale(1)',
          },
          '&.MuiInputLabel-sizeSmall:not(.MuiInputLabel-shrink)': {
            transform: 'translate(14px, 9px) scale(1)',
          },
          '&.MuiInputLabel-shrink': {
            padding: '0 8px',
            marginLeft: -6,
          },
        },
      },
    },
  };
}
